import { render, staticRenderFns } from "./ContractorsModalGeneralTableRow.vue?vue&type=template&id=bb2b7a06&"
import script from "./ContractorsModalGeneralTableRow.vue?vue&type=script&lang=js&"
export * from "./ContractorsModalGeneralTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports